export default "__VITE_ASSET__CCUJDwdK__"